import { first } from 'lodash-es';
import { SECTION_IDS, type SectionId } from '../constants/wizard';
import { getOverviewFromApplication } from '../utils/overview/overview-statuses';
import { REVIEW_STATUS } from '../constants/wizard';
import { logError } from '@zg-rentals/log-error';
import type { ApplicationContextValue } from '../contexts/ApplicationContext';
import type { RentalApplication } from '@zg-rentals/clickstream';

const nullValues = {
  rental_application: {
    application_id: null,
    application_status_cd: null,
    contact_person_nm: null,
    first_visit_ind: null,
    household_info_ind: null,
    identity_verification_ind: null,
    income_history_ind: null,
    interaction_button_txt: null,
    interaction_category_nm: null,
    personal_info_ind: null,
    rawr_treatment_txt: null,
    residence_history_ind: null,
    screening_report_ind: null,
  },
};

export function getRentalApplication(applicationContext: ApplicationContextValue | undefined): RentalApplication {
  try {
    // return null values if applicationData is not available
    if (!applicationContext) {
      return nullValues;
    }

    const { sections } = getOverviewFromApplication(applicationContext);

    const isRequirementMet = (section: SectionId) =>
      first(sections.filter((x) => x.id == section))?.status === REVIEW_STATUS.COMPLETE;

    const { application, isFirstTimeUser } = applicationContext;
    return {
      rental_application: {
        application_id: application.id ?? null,
        // TODO: Check if this matches with the applicantSnapshotStatusTypes object from the old application
        application_status_cd: application.status ?? null,
        contact_person_nm: application.listingOwner?.name ?? null,
        first_visit_ind: isFirstTimeUser ?? null,
        household_info_ind: isRequirementMet(SECTION_IDS.HOUSEHOLD_INFO),
        identity_verification_ind: isRequirementMet(SECTION_IDS.ID_VERIFICATION),
        income_history_ind: isRequirementMet(SECTION_IDS.INCOME_HISTORY),
        interaction_button_txt: null,
        interaction_category_nm: null,
        personal_info_ind: isRequirementMet(SECTION_IDS.PERSONAL_INFO),
        rawr_treatment_txt: 'experiment',
        residence_history_ind: isRequirementMet(SECTION_IDS.RESIDENCE_HISTORY),
        screening_report_ind: isRequirementMet(SECTION_IDS.PAYMENT_AND_REPORTS),
      },
    };
  } catch (error) {
    logError({ error, context: 'getRentalApplication' });
    return nullValues;
  }
}
